enum BulletListIconStyle {
    Bullet,
    Tick,
    Cross
}

interface BulletListItem {
    subtitle?: string;
    text: string;
}

export { BulletListItem, BulletListIconStyle };
